import { render, staticRenderFns } from "./AccessLogsPage.vue?vue&type=template&id=f65e63be&scoped=true"
import script from "./AccessLogsPage.vue?vue&type=script&lang=ts"
export * from "./AccessLogsPage.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f65e63be",
  null
  
)

export default component.exports